import React from 'react';
import * as PropTypes from 'prop-types';

const ModalClose = (props) => {
  return <div onClick={props.onClick} className={'modal-close'} />;
};

ModalClose.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export { ModalClose };
